var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 27,
    viewBox: "0 0 18 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pin / User "
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape",
    opacity: 0.1,
    cx: 9.00138,
    cy: 22.2054,
    rx: 8.12248,
    ry: 4.7952,
    fill: "#AC3049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9524 9.08434C17.9524 14.1012 8.97619 22.7109 8.97619 22.7109C8.97619 22.7109 0 14.1012 0 9.08434C0 6.67502 0.945704 4.36439 2.62907 2.66074C4.31243 0.957098 6.59556 0 8.97619 0C11.3568 0 13.64 0.957098 15.3233 2.66074C17.0067 4.36439 17.9524 6.67502 17.9524 9.08434Z",
    fill: "#0F4590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.83154 12.6631C9.84773 12.6631 10.8223 12.2594 11.5409 11.5409C12.2594 10.8223 12.6631 9.84773 12.6631 8.83154C12.6631 7.81535 12.2594 6.84079 11.5409 6.12223C10.8223 5.40368 9.84773 5 8.83154 5C7.81535 5 6.84079 5.40368 6.12223 6.12223C5.40368 6.84079 5 7.81535 5 8.83154C5 9.84773 5.40368 10.8223 6.12223 11.5409C6.84079 12.2594 7.81535 12.6631 8.83154 12.6631Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.840b0ce731f997558025bd374c36bd4d.svg";
export { ForwardRef as ReactComponent };